var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { waitForFeatureFlags } from '../../feature-flags';
import { getFlagValueForFeature, RECORDING_STARTED_MESSAGE_BY_FEATURE } from './utils';
var FullstoryService = /** @class */ (function () {
    function FullstoryService(fsApi, isInitialized) {
        this.fsApi = null;
        this.isInitialized = function () { return false; };
        this.fsApi = fsApi;
        this.isInitialized = isInitialized;
    }
    FullstoryService.init = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var fullstory, _a, init, FullStory, isInitialized;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        FullstoryService.config = config;
                        window._fs_capture_on_startup = false;
                        return [4 /*yield*/, waitForFeatureFlags()];
                    case 1:
                        fullstory = (_b.sent()).fullstory;
                        if (!(!!fullstory && !!config.orgId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, import('@fullstory/browser')];
                    case 2:
                        _a = _b.sent(), init = _a.init, FullStory = _a.FullStory, isInitialized = _a.isInitialized;
                        init({ orgId: config.orgId });
                        FullstoryService.instance = new FullstoryService(FullStory, isInitialized);
                        FullStory('start');
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FullstoryService.initForFeature = function (featureName) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var flags, isFeatureEnabled, _b, init, FullStory, isInitialized;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!((_a = FullstoryService.instance) === null || _a === void 0 ? void 0 : _a.isInitialized())) return [3 /*break*/, 4];
                        window._fs_capture_on_startup = false;
                        return [4 /*yield*/, waitForFeatureFlags()];
                    case 1:
                        flags = _c.sent();
                        isFeatureEnabled = getFlagValueForFeature(featureName, flags);
                        if (!(!!isFeatureEnabled && !!FullstoryService.config.orgId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, import('@fullstory/browser')];
                    case 2:
                        _b = _c.sent(), init = _b.init, FullStory = _b.FullStory, isInitialized = _b.isInitialized;
                        init({ orgId: FullstoryService.config.orgId });
                        FullstoryService.instance = new FullstoryService(FullStory, isInitialized);
                        FullStory('start');
                        FullstoryService.track(RECORDING_STARTED_MESSAGE_BY_FEATURE[featureName]);
                        _c.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        FullstoryService.track(RECORDING_STARTED_MESSAGE_BY_FEATURE[featureName]);
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FullstoryService.isInitialized = function () {
        var _a;
        return ((_a = FullstoryService.instance) === null || _a === void 0 ? void 0 : _a.isInitialized()) || false;
    };
    FullstoryService.getApi = function () {
        var _a;
        return ((_a = this.instance) === null || _a === void 0 ? void 0 : _a.fsApi) || null;
    };
    FullstoryService.track = function (analyticsEvent, payload) {
        var _a;
        if ((_a = FullstoryService.instance) === null || _a === void 0 ? void 0 : _a.isInitialized()) {
            FullstoryService.instance.fsApi('trackEvent', {
                name: analyticsEvent,
                properties: payload || {},
            });
        }
    };
    FullstoryService.identify = function (id, payload) {
        var _a;
        if ((_a = FullstoryService.instance) === null || _a === void 0 ? void 0 : _a.isInitialized()) {
            FullstoryService.instance.fsApi('setIdentity', {
                uid: id,
                properties: payload || {},
            });
        }
    };
    FullstoryService.instance = null;
    FullstoryService.config = null;
    return FullstoryService;
}());
export { FullstoryService };
